module.exports = __webpack_public_path__ + "static/media/feature-dashboard-management.7e7aa215.png";